import { useState } from "react";
import { faqs } from "@/mocks/events";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
      <div className="lg:col-span-4">
        <span className="mb-2.5 inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700">
          <i className="ri-question-line text-sm"></i>
          常见问题
        </span>
        <h2 className="font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
          第一次来围观的你，可能想知道
        </h2>
        <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
          关于内容来源、热评筛选标准和更新节奏，我们把大家问得最多的问题整理在这里。还有别的疑问，
          欢迎在「关于我们」页给我们留言。
        </p>
      </div>

      <div className="lg:col-span-8">
        <ul className="flex flex-col gap-3">
          {faqs.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <li
                key={item.q}
                className={`overflow-hidden rounded-lg border transition-colors ${
                  isOpen ? "border-primary-300 bg-primary-50" : "border-background-200 bg-background-50"
                }`}
              >
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="font-heading text-base font-bold text-foreground-950">{item.q}</span>
                    <i
                      className={`shrink-0 text-xl transition-transform ${
                        isOpen ? "ri-subtract-line text-primary-600" : "ri-add-line text-foreground-500"
                      }`}
                    ></i>
                  </button>
                </h3>
                {isOpen && (
                  <div className="px-5 pb-5 text-sm leading-relaxed text-foreground-700">{item.a}</div>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}